const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        period: {
          from: "De",
          to: "Até",
          today: "Hoje",
          last7: "7 dias",
          last30: "30 dias"
        },
        cards: {
          inAttendance: "Em atendimento",
          waiting: "Aguardando atendimento",
          onlineUsers: "Atendentes online",
          closed: "Atendimentos finalizados",
          messagesSent: "Mensagens enviadas",
          messagesReceived: "Mensagens recebidas",
          newLeads: "Novos leads",
          avgAttendance: "Tempo médio de atendimento",
          avgWait: "Tempo médio de espera"
        },
        attendants: {
          title: "Atendentes",
          name: "Nome",
          closed: "Atendimentos concluídos",
          avg: "T.M. atendimento",
          status: "Estado (atual)",
          online: "Online",
          offline: "Offline"
        },
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          kanban: "Kanban",
          tags: "Tags",
          schedules: "Agendamentos",
          tasks: "Tarefas",
          calendar: "Calendário",
          internalChat: "Chat Interno",
          campaigns: "Campanhas",
          announcements: "Informativos",
          system: "Sistema",
          companies: "Empresas",
          plans: "Planos",
          connections: "Conexões",
          tickets: "Atendimentos",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          queues: "Filas & Chatbot",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
        },
        appBar: {
          greeting: "Olá {{name}}, bem-vindo à {{company}}!",
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
          darkMode: "Modo escuro",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      tags: {
        title: "Tags",
        buttons: {
          add: "Adicionar tag"
        },
        table: {
          name: "Nome",
          color: "Cor",
          kanban: "Coluna no Kanban",
          position: "Ordem",
          actions: "Ações",
          yes: "Sim",
          no: "Não"
        },
        confirmationModal: {
          deleteTitle: "Excluir a tag",
          deleteMessage: "A tag será removida de todos os atendimentos. Esta ação não pode ser desfeita."
        },
        toasts: {
          deleted: "Tag excluída.",
          saved: "Tag salva."
        }
      },
      tagModal: {
        title: {
          add: "Nova tag",
          edit: "Editar tag"
        },
        form: {
          name: "Nome",
          color: "Cor",
          kanban: "Mostrar como coluna no Kanban",
          position: "Ordem da coluna"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Salvar"
        }
      },
      ticketTags: {
        placeholder: "Adicionar tags",
        noOptions: "Nenhuma tag cadastrada"
      },
      kanban: {
        title: "Kanban",
        open: "Em aberto",
        empty: "Nenhum atendimento",
        pending: "Aguardando",
        noLanes: "Nenhuma tag marcada como coluna do Kanban. Cadastre em Administração > Tags.",
        unassigned: "Sem atendente"
      },
      schedules: {
        title: "Agendamentos",
        loadMore: "Carregar mais",
        buttons: {
          add: "Novo agendamento"
        },
        filters: {
          pending: "Pendentes",
          sent: "Enviados",
          error: "Com erro",
          all: "Todos",
          search: "Pesquisar contato ou mensagem"
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Envio",
          status: "Status",
          user: "Criado por",
          actions: "Ações"
        },
        status: {
          pending: "Pendente",
          sending: "Enviando",
          sent: "Enviado",
          error: "Erro"
        },
        confirmationModal: {
          deleteTitle: "Excluir agendamento",
          deleteMessage: "A mensagem não será enviada. Esta ação não pode ser desfeita."
        },
        toasts: {
          saved: "Agendamento salvo.",
          deleted: "Agendamento excluído."
        },
        empty: "Nenhum agendamento encontrado."
      },
      scheduleModal: {
        title: {
          add: "Agendar mensagem",
          edit: "Editar agendamento"
        },
        form: {
          contact: "Contato",
          body: "Mensagem",
          bodyHelp: "Use {{name}} para inserir o nome do contato.",
          sendAt: "Data e hora do envio"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Agendar",
          okEdit: "Salvar"
        }
      },
      tasks: {
        title: "Tarefas",
        buttons: {
          add: "Nova tarefa"
        },
        filters: {
          mine: "Minhas",
          open: "Abertas",
          overdue: "Atrasadas",
          done: "Concluídas",
          all: "Todas",
          search: "Pesquisar tarefa ou contato"
        },
        table: {
          title: "Tarefa",
          dueAt: "Prazo",
          priority: "Prioridade",
          assignedUser: "Responsável",
          contact: "Contato",
          actions: "Ações"
        },
        priority: {
          low: "Baixa",
          normal: "Normal",
          high: "Alta"
        },
        noDue: "Sem prazo",
        overdue: "Atrasada",
        complete: "Concluir",
        reopen: "Reabrir",
        confirmationModal: {
          deleteTitle: "Excluir tarefa",
          deleteMessage: "Esta ação não pode ser desfeita."
        },
        toasts: {
          saved: "Tarefa salva.",
          deleted: "Tarefa excluída.",
          assigned: "Nova tarefa para você: {{title}}"
        },
        empty: "Nenhuma tarefa encontrada.",
        loadMore: "Carregar mais"
      },
      taskModal: {
        title: {
          add: "Nova tarefa",
          edit: "Editar tarefa"
        },
        form: {
          title: "Título",
          description: "Descrição",
          dueAt: "Prazo",
          priority: "Prioridade",
          assignedUser: "Responsável",
          contact: "Contato (opcional)",
          done: "Concluída"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Salvar",
          delete: "Excluir"
        }
      },
      calendar: {
        title: "Calendário",
        today: "Hoje",
        newTask: "Nova tarefa",
        newSchedule: "Novo agendamento",
        legend: {
          task: "Tarefa",
          taskDone: "Tarefa concluída",
          schedule: "Agendamento",
          scheduleSent: "Agendamento enviado",
          error: "Atrasada / com erro"
        },
        noEvents: "Nada para este dia.",
        more: "+{{count}} mais",
        weekdays: "Dom,Seg,Ter,Qua,Qui,Sex,Sáb"
      },
      internalChat: {
        title: "Chat Interno",
        newChat: "Nova conversa",
        noChats: "Nenhuma conversa ainda. Comece uma com um colega.",
        selectChat: "Selecione uma conversa ou comece uma nova.",
        placeholder: "Digite uma mensagem (Enter envia, Shift+Enter quebra a linha)",
        send: "Enviar",
        loadOlder: "Carregar mensagens anteriores",
        you: "Você",
        members: "{{count}} participantes",
        editGroup: "Editar grupo",
        leave: "Sair da conversa",
        deleteGroup: "Apagar grupo",
        confirmLeave: "Você deixará de ver esta conversa.",
        confirmDelete: "O grupo e todas as mensagens serão apagados para todos.",
        newMessage: "{{name}}: {{body}}",
        modal: {
          titleNew: "Nova conversa",
          titleEdit: "Editar grupo",
          users: "Participantes",
          groupTitle: "Nome do grupo",
          groupHelp: "Obrigatório quando houver mais de um participante.",
          cancel: "Cancelar",
          create: "Começar",
          save: "Salvar"
        }
      },
      campaigns: {
        title: "Campanhas",
        buttons: {
          add: "Nova campanha"
        },
        empty: "Nenhuma campanha ainda.",
        table: {
          name: "Campanha",
          status: "Status",
          progress: "Progresso",
          when: "Início",
          actions: "Ações"
        },
        status: {
          draft: "Rascunho",
          scheduled: "Agendada",
          running: "Enviando",
          paused: "Pausada",
          finished: "Concluída",
          canceled: "Cancelada"
        },
        actions: {
          edit: "Editar",
          start: "Iniciar",
          pause: "Pausar",
          resume: "Retomar",
          cancel: "Cancelar",
          report: "Relatório",
          delete: "Excluir"
        },
        progress: "{{done}} de {{total}}",
        notStarted: "Não iniciada",
        confirm: {
          startTitle: "Iniciar a campanha?",
          startMessage: "As mensagens começam a sair respeitando o intervalo, o horário e o limite diário configurados.",
          cancelTitle: "Cancelar a campanha?",
          cancelMessage: "Os envios pendentes serão descartados. Esta ação não pode ser desfeita.",
          deleteTitle: "Excluir a campanha?",
          deleteMessage: "A campanha e o relatório de envios serão apagados."
        },
        toasts: {
          saved: "Campanha salva.",
          deleted: "Campanha excluída."
        }
      },
      campaignModal: {
        title: {
          add: "Nova campanha",
          edit: "Editar campanha"
        },
        warning: "Envio em massa pelo WhatsApp não oficial pode levar ao banimento do número. Use intervalos longos, poucas mensagens por dia e só para quem já conversa com você.",
        form: {
          name: "Nome da campanha",
          message: "Mensagem {{n}}",
          messageHelp: "Use {{name}} para o nome do contato. Cada envio sorteia uma das variações.",
          addVariation: "Adicionar variação",
          removeVariation: "Remover",
          target: "Destinatários",
          targetAll: "Todos que já conversaram com você",
          targetTags: "Contatos com atendimentos nestas tags",
          targetContacts: "Contatos escolhidos",
          tags: "Tags",
          contacts: "Contatos",
          eligible: "{{count}} contato(s) receberão esta campanha",
          eligibleHelp: "Só entram contatos que já mandaram mensagem para você.",
          scheduledAt: "Começar em (opcional)",
          scheduledHelp: "Em branco: começa quando você clicar em Iniciar.",
          minDelay: "Intervalo mínimo (s)",
          maxDelay: "Intervalo máximo (s)",
          dailyLimit: "Limite por dia",
          hourStart: "Enviar a partir de (h)",
          hourEnd: "Até (h)",
          safety: "Segurança do envio"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Salvar"
        }
      },
      campaignReport: {
        title: "Relatório: {{name}}",
        total: "Total",
        filters: {
          all: "Todos",
          pending: "Pendentes",
          sent: "Enviados",
          error: "Com erro",
          skipped: "Ignorados"
        },
        table: {
          contact: "Contato",
          status: "Status",
          sentAt: "Enviado em",
          detail: "Mensagem / erro"
        },
        status: {
          pending: "Pendente",
          sent: "Enviado",
          error: "Erro",
          skipped: "Ignorado"
        },
        close: "Fechar",
        loadMore: "Carregar mais"
      },
      announcements: {
        title: "Informativos",
        buttons: {
          add: "Novo informativo"
        },
        empty: "Nenhum informativo no momento.",
        priority: {
          low: "Baixa",
          normal: "Normal",
          high: "Alta"
        },
        inactive: "Inativo",
        by: "por {{name}} em {{date}}",
        newToast: "Novo informativo: {{title}}",
        confirmDelete: "Excluir este informativo?",
        toasts: {
          saved: "Informativo salvo.",
          deleted: "Informativo excluído."
        }
      },
      announcementModal: {
        title: {
          add: "Novo informativo",
          edit: "Editar informativo"
        },
        form: {
          title: "Título",
          text: "Texto",
          priority: "Prioridade",
          active: "Ativo (visível para a equipe)"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Salvar"
        }
      },
      companies: {
        title: "Empresas",
        buttons: {
          add: "Nova empresa"
        },
        table: {
          name: "Empresa",
          plan: "Plano",
          usage: "Uso",
          dueDate: "Vencimento",
          status: "Status",
          actions: "Ações"
        },
        usage: "{{users}} usuário(s) · {{connections}} conexão(ões)",
        active: "Ativa",
        inactive: "Inativa",
        noPlan: "Sem plano",
        overdue: "Vencida",
        actions: {
          edit: "Editar",
          activate: "Ativar",
          deactivate: "Desativar",
          delete: "Excluir"
        },
        confirmDeactivate: "Desativar a empresa {{name}}? Ninguém dela conseguirá entrar até ser reativada.",
        confirmDelete: "Excluir DEFINITIVAMENTE a empresa {{name}} e todos os dados dela (contatos, atendimentos, mensagens, usuários)? Esta ação não pode ser desfeita.",
        toasts: {
          saved: "Empresa salva.",
          deleted: "Empresa excluída."
        }
      },
      companyModal: {
        title: {
          add: "Nova empresa",
          edit: "Editar empresa"
        },
        form: {
          name: "Nome da empresa",
          plan: "Plano",
          dueDate: "Vencimento",
          email: "E-mail",
          phone: "Telefone",
          document: "CPF/CNPJ",
          active: "Ativa",
          admin: "Administrador da empresa",
          adminName: "Nome",
          adminEmail: "E-mail de acesso",
          adminPassword: "Senha inicial"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Salvar"
        }
      },
      plans: {
        title: "Planos",
        buttons: {
          add: "Novo plano"
        },
        table: {
          name: "Plano",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
          campaigns: "Campanhas",
          actions: "Ações"
        },
        yes: "Sim",
        no: "Não",
        confirmDelete: "Excluir o plano {{name}}?",
        toasts: {
          saved: "Plano salvo.",
          deleted: "Plano excluído."
        }
      },
      planModal: {
        title: {
          add: "Novo plano",
          edit: "Editar plano"
        },
        form: {
          name: "Nome",
          maxUsers: "Máx. usuários",
          maxConnections: "Máx. conexões",
          maxQueues: "Máx. filas",
          useCampaigns: "Permite campanhas"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Salvar"
        }
      },
      dueBanner: {
        soon: "A assinatura de {{company}} vence em {{days}} dia(s) ({{date}}).",
        today: "A assinatura de {{company}} vence hoje.",
        overdue: "A assinatura de {{company}} está vencida desde {{date}}. Regularize para evitar o bloqueio."
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        schedule: "Agendar mensagem",
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_COMPANY_INACTIVE: "Empresa desativada. Fale com o suporte.",
        ERR_COMPANY_NOT_FOUND: "Empresa não encontrada.",
        ERR_COMPANY_INVALID_NAME: "Informe o nome da empresa (mínimo 2 caracteres).",
        ERR_COMPANY_INVALID_DATE: "Data de vencimento inválida.",
        ERR_COMPANY_ADMIN_REQUIRED: "Informe nome, e-mail e senha do administrador da empresa.",
        ERR_COMPANY_OWN: "Você não pode desativar ou excluir a sua própria empresa.",
        ERR_COMPANY_STILL_ACTIVE: "Desative a empresa antes de excluir.",
        ERR_PLAN_NOT_FOUND: "Plano não encontrado.",
        ERR_PLAN_INVALID_NAME: "Informe o nome do plano.",
        ERR_PLAN_INVALID_LIMIT: "Os limites devem ser números inteiros entre 0 e 9999.",
        ERR_PLAN_NAME_ALREADY_EXISTS: "Já existe um plano com esse nome.",
        ERR_PLAN_IN_USE: "Este plano está em uso por alguma empresa.",
        ERR_PLAN_LIMIT_USERS: "Limite de usuários do plano atingido.",
        ERR_PLAN_LIMIT_CONNECTIONS: "Limite de conexões do plano atingido.",
        ERR_PLAN_LIMIT_QUEUES: "Limite de filas do plano atingido.",
        ERR_PLAN_NO_CAMPAIGNS: "O plano da empresa não inclui campanhas.",
        ERR_CAMPAIGN_NOT_FOUND: "Campanha não encontrada.",
        ERR_CAMPAIGN_INVALID_NAME: "Dê um nome à campanha (2 a 120 caracteres).",
        ERR_CAMPAIGN_INVALID_MESSAGES: "Escreva de 1 a 3 mensagens (até 4096 caracteres cada).",
        ERR_CAMPAIGN_INVALID_TARGET: "Destinatários inválidos.",
        ERR_CAMPAIGN_INVALID_DATE: "Data de início inválida.",
        ERR_CAMPAIGN_INVALID_DELAY: "Intervalo inválido: mínimo de 20 segundos e o máximo não pode ser menor que o mínimo.",
        ERR_CAMPAIGN_INVALID_LIMIT: "O limite diário deve ficar entre 1 e 1000.",
        ERR_CAMPAIGN_INVALID_HOURS: "Horário inválido: o fim precisa ser depois do início.",
        ERR_CAMPAIGN_NOT_EDITABLE: "Só dá para editar campanhas em rascunho ou agendadas.",
        ERR_CAMPAIGN_RUNNING: "Pause ou cancele a campanha antes de excluir.",
        ERR_CAMPAIGN_INVALID_ACTION: "Esta ação não é possível no status atual da campanha.",
        ERR_CAMPAIGN_NO_RECIPIENTS: "Nenhum contato elegível para esta campanha.",
        ERR_ANNOUNCEMENT_NOT_FOUND: "Informativo não encontrado.",
        ERR_ANNOUNCEMENT_INVALID_TITLE: "O título precisa ter entre 2 e 150 caracteres.",
        ERR_ANNOUNCEMENT_INVALID_TEXT: "Escreva o texto do informativo.",
        ERR_ANNOUNCEMENT_INVALID_PRIORITY: "Prioridade inválida.",
        ERR_CHAT_NOT_FOUND: "Conversa não encontrada.",
        ERR_CHAT_INVALID_USERS: "Escolha pelo menos um participante válido.",
        ERR_CHAT_INVALID_TITLE: "Dê um nome ao grupo (mínimo 2 caracteres).",
        ERR_CHAT_INVALID_BODY: "Mensagem vazia ou longa demais.",
        ERR_TASK_NOT_FOUND: "Tarefa não encontrada.",
        ERR_TASK_INVALID_TITLE: "O título precisa ter entre 2 e 200 caracteres.",
        ERR_TASK_INVALID_DATE: "Prazo inválido.",
        ERR_TASK_INVALID_PRIORITY: "Prioridade inválida.",
        ERR_TASK_INVALID_STATUS: "Status inválido.",
        ERR_TASK_INVALID_USER: "Responsável inválido.",
        ERR_TASK_INVALID_CONTACT: "Contato inválido.",
        ERR_SCHEDULE_NOT_FOUND: "Agendamento não encontrado.",
        ERR_SCHEDULE_INVALID_BODY: "Escreva a mensagem (até 4096 caracteres).",
        ERR_SCHEDULE_INVALID_CONTACT: "Escolha um contato válido (grupos não são aceitos).",
        ERR_SCHEDULE_INVALID_DATE: "Escolha uma data e hora no futuro.",
        ERR_SCHEDULE_ALREADY_SENT: "Este agendamento já foi enviado e não pode ser alterado.",
        ERR_TAG_INVALID_NAME: "Nome da tag inválido (mínimo 2 caracteres).",
        ERR_TAG_NAME_ALREADY_EXISTS: "Já existe uma tag com esse nome.",
        ERR_TAG_INVALID_COLOR: "Cor inválida.",
        ERR_TAG_NOT_FOUND: "Tag não encontrada.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
      },
    },
  },
};

export { messages };
